// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import inventoryApi from '~/apis/inventory';
import {
  CLONE_INVENTORY,
  CREATE_INVENTORY,
  DELETE_INVENTORY,
  EXPORT_INVENTORY,
  GET_DETAIL_INVENTORY,
  GET_LIST_INVENTORY_HISTORY,
  GET_LIST_INVENTORY_PRODUCT,
  GET_LIST_INVENTORY_QUOTE,
  IMPORT_INVENTORY,
  UPDATE_INVENTORY,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  ICloneProduct,
  IParamDetailInventory,
  IParamInventoryHistory,
  IParamInventoryProduct,
  IParamInventoryQuote,
} from '~/utils/interface/inventory';

export const getListInventoryQuote = createAsyncThunk(
  GET_LIST_INVENTORY_QUOTE,
  async (params: IParamInventoryQuote, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.getListInventoryQuote(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListInventoryProduct = createAsyncThunk(
  GET_LIST_INVENTORY_PRODUCT,
  async (params: IParamInventoryProduct, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.getListInventoryProduct(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListInventoryHistory = createAsyncThunk(
  GET_LIST_INVENTORY_HISTORY,
  async (params: IParamInventoryHistory, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.getListInventoryHistory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailInventory = createAsyncThunk(
  GET_DETAIL_INVENTORY,
  async (params: IParamDetailInventory, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.getDetailInventory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createInventory = createAsyncThunk(CREATE_INVENTORY, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await inventoryApi.createInventory(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const importInventory = createAsyncThunk(IMPORT_INVENTORY, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await inventoryApi.importInventory(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteInventory = createAsyncThunk(DELETE_INVENTORY, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await inventoryApi.deleteInventory(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateInventory = createAsyncThunk(
  UPDATE_INVENTORY,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.updateInventory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportInventory = createAsyncThunk(
  EXPORT_INVENTORY,
  async (params: IParamInventoryProduct, { rejectWithValue }) => {
    try {
      const resp = await inventoryApi.exportInventory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const cloneInventory = createAsyncThunk(CLONE_INVENTORY, async (body: ICloneProduct, { rejectWithValue }) => {
  try {
    const resp = await inventoryApi.cloneInventory(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
